import { useState, useEffect } from "react";
import { useNavigate, Link, useSearchParams } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import AuthShell from "@/components/AuthShell";
import { toast } from "sonner";

export default function Signup() {
  const { register, user } = useAuth();
  const nav = useNavigate();
  const [sp] = useSearchParams();
  const next = sp.get("next");
  useEffect(() => { const p = sp.get("plan"); if (p) localStorage.setItem("certy_plan_intent", p); }, [sp]);
  const [name, setName] = useState("");
  const [email, setEmail] = useState(new URLSearchParams(window.location.search).get("email") || "");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => { if (user) nav(next || (user.onboarding_complete ? "/dashboard" : "/onboarding")); }, [user, nav, next]);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 8) return toast.error("Password must be at least 8 characters");
    setLoading(true);
    try {
      await register(email, password, name);
      nav(next || "/onboarding");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Could not create account");
    } finally { setLoading(false); }
  };

  return (
    <AuthShell title="Create your account" subtitle="14-day free trial · no card required"
      footer={<>Already have an account? <Link to="/login" className="text-emerald-brand font-semibold">Sign in</Link></>}>
      <form onSubmit={submit} className="space-y-3">
        <input data-testid="signup-name" required value={name} onChange={(e) => setName(e.target.value)} placeholder="Full name"
          className="w-full min-h-[48px] px-4 rounded-xl border border-input bg-card focus:ring-2 focus:ring-emerald-500 focus:outline-none" />
        <input data-testid="signup-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email address"
          className="w-full min-h-[48px] px-4 rounded-xl border border-input bg-card focus:ring-2 focus:ring-emerald-500 focus:outline-none" />
        <input data-testid="signup-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Create a password (min 8 chars)"
          className="w-full min-h-[48px] px-4 rounded-xl border border-input bg-card focus:ring-2 focus:ring-emerald-500 focus:outline-none" />
        <button data-testid="signup-submit" disabled={loading} className="w-full min-h-[48px] rounded-xl bg-emerald-brand hover:bg-emerald-deep text-white font-semibold transition-colors disabled:opacity-60">
          {loading ? "Creating…" : "Start free trial"}
        </button>
      </form>
    </AuthShell>
  );
}
